import { Star, ArrowRight } from "lucide-react";

export const GOOGLE_PROFILE_URL = "https://share.google/RdEH3SKvT91YTuvaQ";

const GoogleG = ({ className = "h-8 w-8" }) => (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.3-2.2H12v4.1h6.5c-.1 1.1-.8 2.7-2.4 3.8l3.7 2.9c2.2-2.1 3.7-5.1 3.7-8.6z" />
        <path fill="#34A853" d="M12 24c3.2 0 6-1.1 8-2.9l-3.7-2.9c-1 .7-2.4 1.2-4.3 1.2-3.3 0-6-2.2-7-5.3l-3.9 3C3.1 21.3 7.2 24 12 24z" />
        <path fill="#FBBC05" d="M5 12c0-1.2.2-2.4.7-3.4l-3.9-3C.7 7.3 0 9.6 0 12s.7 4.7 1.8 6.4l3.9-3C5.3 14.4 5 13.2 5 12z" />
        <path fill="#EA4335" d="M12 4.7c1.8 0 3 .8 3.7 1.4l3.3-3.2C17.9 1.1 15.2 0 12 0 7.2 0 3.1 2.7 1.2 6.6l3.9 3c1-3.1 3.7-4.9 7-4.9z" />
    </svg>
);

const GoogleRating = ({ testidPrefix = "google" }) => (
    <div data-testid={`${testidPrefix}-rating-card`} className="flex flex-col gap-6 rounded-3xl border border-black/10 bg-white p-6 shadow-sm sm:flex-row sm:items-center sm:justify-between sm:p-8">
        <div className="flex items-center gap-5">
            <GoogleG />
            <div>
                <div className="flex items-center gap-3">
                    <span className="font-display text-3xl font-black text-night">5,0/5</span>
                    <div className="flex gap-0.5 text-brand" aria-label="5 étoiles sur 5">
                        {[...Array(5)].map((_, s) => (
                            <Star key={s} className="h-4 w-4 fill-current" />
                        ))}
                    </div>
                </div>
                <p className="mt-1 text-sm text-slate-600">Note Google de notre entreprise</p>
            </div>
        </div>
        <div className="flex flex-wrap gap-3">
            <a
                data-testid={`${testidPrefix}-review-button`}
                href={GOOGLE_PROFILE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3.5 font-bold text-white transition-[background-color,transform] duration-300 hover:bg-brand-hover hover:scale-105 active:scale-95"
            >
                <Star className="h-4 w-4" />
                Laisser un avis Google
            </a>
            <a
                data-testid={`${testidPrefix}-profile-link`}
                href={GOOGLE_PROFILE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-black/15 px-6 py-3.5 font-bold text-night transition-[border-color,background-color] duration-300 hover:border-brand hover:bg-black/5"
            >
                Voir notre fiche
                <ArrowRight className="h-4 w-4 text-brand" />
            </a>
        </div>
    </div>
);

export default GoogleRating;
